import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    height: 500,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    gridGap: theme.spacing(1),
  },
  titleContainer: {
    flexGrow: 1,
    overflow: 'hidden',
  },
  dateRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
  },
  dateBoxLight: {
    display: 'flex',
    alignItems: 'center',
    gridGap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    borderRadius: 8,
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.background.default,
  },
  dateBoxDark: {
    display: 'flex',
    alignItems: 'center',
    gridGap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    borderRadius: 8,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}))

export default useStyles
